import * as React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, Paper } from "@mui/material";
import CustomButton from "components/Button";
import CustomTextField from "components/TextField";
import PhoneInputWithCountry from "components/PhoneField";
import { observer } from "mobx-react";
import store from "./store";
import { useNavigate } from "react-router-dom";

const ChangePassword = observer(() => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    store.setNavigateFunction(navigate);
    
    // Загружаем профиль пользователя при монтировании компонента
    (async () => {
      await store.getMyProfile();
    })();
    
    // Очистка при размонтировании
    return () => {
      store.clearStore();
    };
  }, [navigate]);

  return (
    <Container>
      <Paper style={{ padding: 20 }}>
        {/* Секция редактирования профиля */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2>{translate("label:Profile:title")}</h2>
          </Grid>

          <Grid item md={12} xs={12}>
            <CustomTextField
              name="username"
              label={translate("label:Profile:username")}
              id="username"
              // autoComplete="off"
              helperText={store.touched.username ? store.errors.username : ""}
              error={!!store.errors.username && !!store.touched.username}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("username")}
              value={store.username}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              id="full_name"
              label={translate("label:Profile:fullName")}
              name="full_name"
              // autoComplete="off"
              helperText={store.touched.full_name ? store.errors.full_name : ""}
              error={!!store.errors.full_name && !!store.touched.full_name}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("full_name")}
              value={store.full_name}
            />
          </Grid>

          <Grid item md={12} xs={12}>
            <CustomTextField
              name="email"
              label={translate("label:Profile:email")}
              id="email"
              type="email"
              // autoComplete="off"
              helperText={store.touched.email ? store.errors.email : ""}
              error={!!store.errors.email && !!store.touched.email}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("email")}
              value={store.email}
            />
          </Grid>

          <Grid item md={12} xs={12}>
            <PhoneInputWithCountry
              value={store.phone}
              onChange={(value, country) => store.handlePhoneChange(value, country)}
              id="phone"
              label={translate("label:Profile:phone")}
              error={!!(store.errors.phone && store.touched.phone)}
              helperText={store.touched.phone ? store.errors.phone : ""}
              defaultCountryId="kg"
            />
          </Grid>

          <Grid item xs={12}>
            <CustomButton
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              id="saveProfileButton"
              onClick={() => {
                store.onUpdateProfile();
              }}
            >
              {translate("label:Profile:saveChanges")}
            </CustomButton>
          </Grid>
        </Grid>
        
        {/* Секция смены пароля */}
        <Grid container spacing={3} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <h2>{translate("label:ChangePassword:title")}</h2>
          </Grid>
          
          {/* Скрытое поле для предотвращения автозаполнения */}
          <input
            type="password"
            autoComplete="new-password"
            style={{ display: 'none' }}
            tabIndex={-1}
          />
          
          <Grid item xs={12}>
            <CustomTextField
              id="CurrentPassword"
              label={translate("label:ChangePassword:currentPassword")}
              type="password"
              name="CurrentPassword"
              // autoComplete="new-password"
              helperText={store.touched.CurrentPassword ? store.errors.CurrentPassword : ""}
              error={!!store.errors.CurrentPassword && !!store.touched.CurrentPassword}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("CurrentPassword")}
              value={store.CurrentPassword}
            />
          </Grid>
          
          <Grid item md={12} xs={12}>
            <CustomTextField
              name="NewPassword"
              label={translate("label:ChangePassword:newPassword")}
              type="password"
              id="NewPassword"
              // autoComplete="new-password"
              helperText={store.touched.NewPassword ? store.errors.NewPassword : ""}
              error={!!store.errors.NewPassword && !!store.touched.NewPassword}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("NewPassword")}
              value={store.NewPassword}
            />
          </Grid>
          
          <Grid item md={12} xs={12}>
            <CustomTextField
              name="ConfirmPassword"
              label={translate("label:ChangePassword:confirmPassword")}
              type="password"
              id="ConfirmPassword"
              // autoComplete="new-password"
              helperText={store.touched.ConfirmPassword ? store.errors.ConfirmPassword : ""}
              error={!!store.errors.ConfirmPassword && !!store.touched.ConfirmPassword}
              onChange={(event) => store.handleChange(event)}
              onBlur={() => store.handleBlur("ConfirmPassword")}
              value={store.ConfirmPassword}
            />
          </Grid>
          
          <Grid item xs={12}>
            <CustomButton
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              id="changePasswordButton"
              onClick={() => {
                store.onChangePassword();
              }}
            >
              {translate("label:ChangePassword:changePassword")}
            </CustomButton>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
});

export default ChangePassword;